var render = function render(){var _vm=this,_c=_vm._self._c;return _c('basic-container',[_c('avue-crud',{ref:"crud",attrs:{"option":_vm.option,"table-loading":_vm.loading,"data":_vm.data,"page":_vm.page},on:{"update:page":function($event){_vm.page=$event},"on-load":_vm.onLoad,"search-change":_vm.searchChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }